import axios from "axios";

/**
 * Extrai a mensagem de erro de um campo que pode ser string ou array
 */
function extractMessage(message: unknown, fallback = "Ocorreu um erro ao processar sua solicitação."): string {
  if (Array.isArray(message)) return message[0] ?? fallback;
  if (typeof message === "string" && message.length > 0) return message;
  return fallback;
}

/**
 * Handle API errors and return standardized error object
 */
export function handleApiError(error: any) {
  if (error.response && error.response.data) {
    return {
      status: "error",
      statusCode: error.status,
      message: extractMessage(error.response.data.message),
    };
  }

  if (!error.response) {
    return {
      status: "error",
      statusCode: error.status,
      message: extractMessage(error.message),
    };
  }

  if (error.response.data) {
    return error.response.data;
  }

  if (axios.isAxiosError(error) && error.response?.status === 401) {
    return {
      status: "error",
      statusCode: 401,
      message: extractMessage(error.message),
    };
  }

  if (axios.isAxiosError(error)) {
    return {
      status: "error",
      statusCode: error.response?.status || 500,
      message: extractMessage(error.response?.data?.message),
    };
  }

  return {
    status: "error",
    statusCode: 500,
    message: extractMessage(error.message),
  };
}
